export const API_URL = process.env.REACT_APP_API_URL
export const AUTH_STORE_NAMESPACE = 'sg-token-client'
export const LOCALIZE_STORE_NAMESPACE = 'localize'
export const AWS_COGNITO_REGION = process.env.REACT_APP_AWS_COGNITO_REGION
export const AWS_COGNITO_USER_POOL_ID = process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID
export const AWS_COGNITO_WEB_CLIENT_ID = process.env.REACT_APP_AWS_COGNITO_WEB_CLIENT_ID
